"use client";

import React, { ReactNode } from "react";

const cssVarName = "--text-multiplier";

export default function TextSizeButton({
  children,
  className,
}: Readonly<{ children: ReactNode; className: string }>) {
  const handleClick = () => {
    const docStyle = document.documentElement.style;
    const currentMultiplier = docStyle.getPropertyValue(cssVarName) || "1";

    if (currentMultiplier === "1.15") docStyle.setProperty(cssVarName, "1.3");
    if (currentMultiplier === "1.3") docStyle.setProperty(cssVarName, "1");
    if (currentMultiplier === "1") docStyle.setProperty(cssVarName, "1.15");
  };

  return (
    <button className={className} onClick={() => handleClick()}>
      {children}
    </button>
  );
}
